// Canonical report document registry.
import { report202610TopPartyGamesAndStreamersDocument } from './2026-10-top-party-games-and-streamers';
import { report202609TopPartyGamesAndStreamersDocument } from './2026-09-top-party-games-and-streamers';
import { report202608TopPartyGamesAndStreamersDocument } from './2026-08-top-party-games-and-streamers';
import { report202607TopPartyGamesAndStreamersDocument } from './2026-07-top-party-games-and-streamers';
import { report202606TopPartyGamesAndStreamersDocument } from './2026-06-top-party-games-and-streamers';
import { report202605TopPartyGamesAndStreamersDocument } from './2026-05-top-party-games-and-streamers';
import { report202604TopPartyGamesAndStreamersDocument } from './2026-04-top-party-games-and-streamers';
import { report202603TopPartyGamesAndStreamersDocument } from './2026-03-top-party-games-and-streamers';
import { report202602TopPartyGamesAndStreamersDocument } from './2026-02-top-party-games-and-streamers';
export const reportDocuments = [
    report202610TopPartyGamesAndStreamersDocument,
    report202609TopPartyGamesAndStreamersDocument,
    report202608TopPartyGamesAndStreamersDocument,
    report202607TopPartyGamesAndStreamersDocument,
    report202606TopPartyGamesAndStreamersDocument,
    report202605TopPartyGamesAndStreamersDocument,
    report202604TopPartyGamesAndStreamersDocument,
    report202603TopPartyGamesAndStreamersDocument,
    report202602TopPartyGamesAndStreamersDocument,
];
export const reportDocumentsBySlug = Object.fromEntries(reportDocuments.map((document) => [document.slug, document]));
export * from './2026-03-top-party-games-and-streamers';
export * from './2026-02-top-party-games-and-streamers';
export * from './2026-04-top-party-games-and-streamers';
export * from './2026-05-top-party-games-and-streamers';
export * from './2026-06-top-party-games-and-streamers';
export * from './2026-07-top-party-games-and-streamers';
export * from './2026-08-top-party-games-and-streamers';
export * from './2026-09-top-party-games-and-streamers';
export * from './2026-10-top-party-games-and-streamers';
//# sourceMappingURL=index.js.map